import angular from 'angular';
import csmCommonWeb from 'csm-common-web';

export default angular
  .module('books.util.vendors.typeahead', [csmCommonWeb])
  .config(typeaheadConfig).name;
  
/*******************************************************************************
 * Config
 *
 * Decorator for the Angular UI typeahead. Adds the autocomplete attribute with
 * non-standard value on the input element to prevent browser suggestions
 * interfering with typeahead results.
 *******************************************************************************/
/* @ngInject */ function typeaheadConfig($provide) {
  $provide.decorator('uibTypeaheadDirective', function ($delegate) {
    var directive =
      $delegate[0]; /* save reference to original typeahead directive */
    var link = directive.link;

    directive.compile = function () {
      return {
        post: function (scope, element) {
          element[0].setAttribute('autocomplete', 'unknown-field-category');
          link.apply(this, arguments);
        }
      };
    };
    delete directive.link;

    return $delegate;
  });
}

typeaheadConfig.$inject = ['$provide'];